import anime from 'animejs';
import medusa from '@/scripts/medusa';
import { SplitText } from '@/scripts/SplitText';

export default {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    el.setAttribute('data-showText', true);
    medusa.ref.pushToTarget('showText', el);

    // eslint-disable-next-line no-param-reassign
    el.splitted = new SplitText(el, {
      type: 'lines',
      linesClass: 'text-line-appear',
      reduceWhiteSpace: true,
    });

    anime.set(el.splitted.lines, {
      translateZ: 0,
      translateY: 40,
      opacity: 0,
    });
  },
  unbind(el) {
    if (el.hasAttribute('data-showText')) medusa.ref.pullFromTarget('showText', el);
  },
};
